export default __webpack_public_path__ + "static/listing-2-8868336167fb17df7370a8965dd7605b.png";